export const APP_DRAWER_WIDTH = 550;

// The IDs of any drawers using the AppDrawer component and context.
export const APP_DRAWER_IDS = {
  CTA_DRAWER: 'cta-drawer'
};

// These are the defaults from MUI
export const DEFAULT_TRANSITION_DURATION = {
  enter: 225,
  exit: 195
};
